import Api from '../../../../Api';
import { IExport } from '../../../../shared-interfaces/IExport';

const map = (record: IExport): IExport => {
  return {
    ...record,
    createdOn: new Date(record.createdOn),
    expiresOn: new Date(record.expiresOn),
    completedOn: record.completedOn ? new Date(record.completedOn) : undefined,
    download: record.download
      ? {
          url: record.download.url,
          expiresOn: new Date(record.download.expiresOn),
        }
      : undefined,
  };
};

const ExportService = {
  getExportStatuses: async (): Promise<IExport[]> => {
    const response = await Api.get(`management/user/export`);
    return response.data
      .map((x: IExport) => map(x))
      .sort(
        (a: IExport, b: IExport) =>
          b.createdOn.getTime() - a.createdOn.getTime(),
      );
  },
  getExportStatus: async (id: string): Promise<IExport> => {
    const response = await Api.get(`management/user/export/${id}`);
    return map(response.data);
  },
  startExport: async (): Promise<IExport> => {
    const response = await Api.post(`management/user/export`);
    return map(response.data);
  },
};

export default ExportService;
